module.exports = __webpack_public_path__ + "img/rcfw.5b6e7360.png";